<template>
  <div id="profile-form" class="h-100">
    <div class="row h-100">
      <div class="col-xl-12 col-md-12 col-sm-12" style="height:calc(100% - 48px);overflow-y: scroll;">
        <card>
          <form>
            <div class="row justify-content-center">
              <div class="col-md-4 col-6 profile-image" :style="{
                  backgroundImage:
                      'url(' +
                        (patient.profileImage
                          ? baseUrl + '/file/' + patient.profileImage
                          : avatarImage) +
                        ')',
                }">
                <n-button type="primary" size="lg" round icon class="camera-button" @click.native="takePic()">
                  <i class="fa fa-camera"></i>
                </n-button>
              </div>
            </div>
            <div class="row">
              <h4 class="sub-heading col-md-12">
                {{ $t("message.Enter Details") }}
              </h4>
              <div class="col-md-6">
                <fg-input type="text" :label="$t('message.First Name')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.First Name')" v-model="patient.firstName" name="firstName" v-validate="modelValidations.firstName" :error="getError('firstName')"></fg-input>
              </div>
              <div class="col-md-6">
                <fg-input type="text" :label="$t('message.Last Name')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.Last Name')" v-model="patient.lastName" name="lastName" v-validate="modelValidations.lastName" :error="getError('lastName')"></fg-input>
              </div>
              <div class="col-12 col-md-4 form-group">
                <label for="" class="mb-0 pl-1">{{$t('message.Gender')}}</label>
                <div style="display:flex;justify-content:start;">
                  <n-radio class="pr-2" v-model="patient.gender" label="male">{{$t('message.Male')}}</n-radio>
                  <n-radio class="pr-2" v-model="patient.gender" label="female">{{$t('message.Female')}}</n-radio>
                  <n-radio class="pr-2" v-model="patient.gender" label="others">{{$t('message.Others')}}</n-radio>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-12 ">
                    <div style="position: relative;">
                      <fg-input name="age" type="number" :label="$t('message.Age')" labelClasses="float-input-label" v-model="patientAge" v-validate="modelValidations.age" :placeholder="$t('message.Age')" inputClasses="pb-1" :error="getError('age')">
                      </fg-input>

                      <div style="position: absolute; top: 0px; inset-inline-end: 0px; width:35%;" id="age-dropdown">
                        <el-select style="width: 100%;" class="form-group select-primary" size="large" name="latestStatus" placeholder="years" v-model="ageUnit">
                          <el-option class="select-primary" value="years" :label="$t('message.Years')"></el-option>
                          <el-option class="select-primary" value="months" :label="$t('message.Months')"></el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <VuePhoneNumberInput style="direction: ltr;" v-model="mobileNumber" :border-radius="25" default-country-code="IN" :preferred-countries="['IN']" @update="mobileNumberUpdate" />
                <div class="text-danger invalid-feedback mt-2" style="display: block" v-if="mobileNumber && !isValidMobile">
                  {{ $t("message.Please enter valid mobile number") }}
                </div>
              </div>

              <div class="col-md-12" v-if="
                  patient.identificationType === 'Aadhar' ||
                  patient.identificationType === 'Voter' ||
                  patient.identificationType === 'Ration'
                ">
                <fg-input type="text" :label="$t('message.Identification Details')" :placeholder="$t('message.Identification Details')" v-model="patient.identificationDetails"></fg-input>
              </div>
            </div>

            <div class="row" style="margin-top: 1em;">
              <div class="col-12">
                <fg-input :label="$t('message.Email')" labelClasses="float-input-label" inputClasses="pb-1" name="email" :placeholder="$t('message.Email')" v-model="patient.email" v-validate="modelValidations.email" :error="getError('email')"></fg-input>
              </div>
            </div>

            <div class="row">
              <h4 class="sub-heading col-md-12">
                {{ $t("message.Address Details") }}
              </h4>
              <div class="col-md-6">
                <fg-input type="text" :label="$t('message.Address line 1')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.Address line 1')" v-model="patient.address.line1" name="addressline1"></fg-input>
              </div>
              <div class="col-md-6">
                <fg-input type="text" :label="$t('message.Address line 2')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.Address line 2')" v-model="patient.address.line2" name="addressline2"></fg-input>
              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-6">
                    <fg-input type="text" :label="$t('message.City')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.City')" v-model="patient.address.city" name="city"></fg-input>
                  </div>
                  <div class="col-6">
                    <fg-input type="text" :label="$t('message.State')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.State')" v-model="patient.address.state" name="state"></fg-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <fg-input type="text" :label="$t('message.Country')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.Country')" v-model="patient.address.country" name="country"></fg-input>
                  </div>
                  <div class="col-6">
                    <fg-input type="text" :label="$t('message.Zip Code')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.Zip Code')" v-model="patient.address.zip" name="zip"></fg-input>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </card>
      </div>
    </div>
    <n-button native-type="submit" type="primary" round size="lg" @click.native="validatePatient()" class="validate-patient-button">
      <i class="fa fa-check pr-1"></i>
      {{$t('message.Create Patient')}}
    </n-button>
    <modal :alertModal="alertModal"></modal>
  </div>
</template>
<script>
import Modal from "../components/Alert";
var moment = require("moment");
import { Select, Option } from "element-ui";
import avatarImage from "@/assets/img/proAvatar.png";

export default {
  components: {
    Modal,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      patient: {
        profileImage: "",
        firstName: "",
        address: {},
        mobileNumber: "",
      },
      ageUnit: "years",
      patientAge: null,
      patientAgeYears: null,
      patientAgeMonths: null,
      alertModal: {
        show: false,
        message: "no message",
        status: "success",
        close: false,
      },
      avatarImage,
      profileImage: "",
      mobileNumber: null,
    };
  },
  computed: {
    modelValidations() {
      return {
        firstName: {
          required: true,
          alpha_spaces: true,
        },
        lastName: {
          required: true,
          alpha_spaces: true,
        },
        age: {
          required: true,
          min_value: 1,
          max_value: this.ageUnit == "years" ? 120 : 11,
        },
        gender: {
          required: true,
        },
        religion: {
          required: true,
        },
        relation: {
          required: true,
        },
        realtionName: {
          required: true,
        },
        caste: {
          required: true,
        },
        email: {
          email: true,
        },
      };
    },
  },
  methods: {
    validatePatient() {
      this.$refs.patientData.validatePatient();
    },

    async createPatient() {
      try {
        this.alertModal.status = "busy";
        this.alertModal.message = this.$t("message.Creating Patient Records");
        this.alertModal.show = true;
        if (this.user.roles.indexOf("nurse") > -1) {
          //Setting username and password by default
          //Commented to fix username not unique error
          /*    this.patient.username = this.patient.password =
            this.patient.patientId || this.patient.mobileNumber; */
        }

        if (this.patient.gender === undefined || this.patient.gender === "")
          this.error = "Select a gender";
        else if (this.patient.dob === undefined || this.patient.dob === "")
          this.error = "Select Date of birth";
        else if (
          this.user.roles.indexOf("nurse") < 0 &&
          (this.patient.username === undefined || this.patient.username === "")
        )
          this.error = "Enter a username";
        else {
          this.patient.roles = ["patient"];

          let patient = await this.$store.dispatch(
            "createPatient",
            this.patient
          );

          this.alertModal.show = false;

          this.$notify({
            type: "info",
            horizontalAlign: "center",
            verticalAlign: "bottom",
            message: this.$t("message.Patient created successfully"),
            closeOnClick: false,
          });
          this.$router.push({ path: "/patients/view/" + patient._id });
        }
      } catch (e) {
        let errorMessage = "";
        if (e.response && e.response.data && e.response.data.message) {
          errorMessage = e.response.data.message;
        }

        this.alertModal.show = false;
        swal.fire({
          title: `Oops!`,
          text: errorMessage || this.$t("message.Unable to create patient"),
          type: "error",
          allowOutsideClick: false,
        });

        this.error = e.data.message;
      }
    },
    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validatePatient() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid && !(this.mobileNumber && !this.isValidMobile)) {
          this.createPatient();
        }
      });
    },
    mobileNumberUpdate(payload) {
      this.isValidMobile = payload.isValid;
      this.patient.mobileNumber = payload.formattedNumber;
    },

    takePic() {
      var _this = this;
      let cameraOptions = {
        sourceType: Camera.PictureSourceType.CAMERA,
        destinationType: Camera.DestinationType.DATA_URL,
        mediaType: Camera.MediaType.PICTURE,
        //allowEdit: true,
        correctOrientation: false,
        encodingType: Camera.EncodingType.PNG,
        quality: 10,
        cameraDirection: Camera.Direction.BACK,
        targetWidth: 150,
        targetHeight: 210,
      };
      navigator.camera.getPicture(
        function (base64Data) {
          let fileData = "data:image/png;base64," + base64Data;
          let fileBlob = _this.dataURItoBlob(fileData);
          let fileToSave = {
            name: _this.patient.firstName + "-profileImage" + ".png",
            data: fileBlob,
            type: "image/png",
            size: fileBlob.size,
          };
          _this.saveFile(fileToSave);
        },
        function (err) {},
        cameraOptions
      );
    },
    async saveFile(file) {
      //if file size is> 10MB, reject
      //1000000
      let _this = this;
      if (file.size / 1000000 > 10) {
        swal.fire({
          title: _this.$t("message.Ooops!"),
          text: _this.$t("message.Maximum file size allowed is 10MB!"),
          type: "error",
          timer: 5000,
        });
      } else {
        let loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        try {
          let _file = await _this.$store.dispatch("uploadProfileImage", file);
          console.log(_file);
          _this.patient.profileImage = _file.fileId;
          console.log(_this.patient);
          loader.hide();
          swal.fire({
            title: _this.$t("message.Success!"),
            text: _this.$t("message.File saved Successfully"),
            type: "success",
            timer: 3000,
          });
        } catch (err) {
          loader.hide();
          swal.fire({
            title: _this.$t("message.Ooops!"),
            text: _this.$t("message.Error while uploading file!"),
            type: "error",
            timer: 5000,
          });
        }
      }
    },
    calculateDob() {
      if (this.ageUnit == "years") {
        this.patientAgeMonths = null;
        this.patientAgeYears = this.patientAge;
      }

      if (this.ageUnit == "months") {
        this.patientAgeYears = null;
        this.patientAgeMonths = this.patientAge;
      }

      let currentYear = new Date().getUTCFullYear();
      let yearOFBirth = currentYear - (this.patientAgeYears || 0);

      let currentMonth = new Date().getMonth() + 1;
      let monthOfBirth = currentMonth - (this.patientAgeMonths || 0);

      if (monthOfBirth == 0 || Math.sign(monthOfBirth) == -1) {
        --yearOFBirth;
        monthOfBirth = 12 + monthOfBirth;
      }
      this.patient.dob = monthOfBirth + "/01/" + yearOFBirth;
    },
  },
  watch: {
    ageUnit: function () {
      this.calculateDob();
    },
    patientAge: function () {
      this.calculateDob();
    },
  },
};
</script>
<style lang="scss">
#profile-form .tab-content.tab-subcategories {
  width: 100%;
}

.danger {
  margin-top: 0.25rem;
  font-size: 80%;
  display: block;
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
  color: #ff3636 !important;
  width: 100%;
}
.el-select {
  width: 75%;
}
</style>


<style scoped>
/deep/ #age-dropdown input {
  height: 40px;
  border-start-start-radius: 0;
  border-end-start-radius: 0;
  border-style: none;
  border-inline-start-style: solid;
  background-color: transparent !important;
  color: #9a9a9a;
}

/deep/ .validate-patient-button {
  top: auto;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  z-index: 2001;
}
[dir="rtl"] /deep/ .validate-patient-button {
  transform: translateX(50%);
}

.camera-button {
  position: absolute;
  top: 6em;
  inset-inline-end: -1em;
}
.profile-image {
  height: 150px;
  max-width: 150px;
}
/deep/.float-input-label {
  position: absolute;
  font-size: 0.65em;
  padding-left: 2em;
  color: var(--color-primary);
  top: 0.2em;
}
/deep/.float-input-label.age {
  top: 0.9em;
}
</style>
